// extracted by mini-css-extract-plugin
module.exports = {"yourekoContainer":"Youreko_yourekoContainer__P0Ft6"};